import { RouteComponentProps, useLocation } from '@reach/router';
import React, { useEffect } from 'react';

interface PublicRouteProps extends RouteComponentProps {
	component: React.ElementType;
	[x: string]: any;
}

function PublicRoute(props: PublicRouteProps) {
	const { component: Component, ...rest } = props;

	const location = useLocation();

	return <Component {...rest} />;
}

export default PublicRoute;
